"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EDIT_CLASS_ROUTE = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const helper_1 = require("components/layout/helper");
const constants_1 = require("configs/routes/constants");
const withSuspense_1 = __importDefault(require("hoc/withSuspense"));
const ClassContent = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./classContent/ClassContent'))));
const ClassListView = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./classListView/ClassListView'))));
const ClassManager = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./ClassManager'))));
exports.EDIT_CLASS_ROUTE = `${constants_1.ROUTES.CLASS.EDIT}/:tabName?`;
class ClassManagerIndex extends react_1.Component {
    render() {
        return ((0, jsx_runtime_1.jsxs)(react_router_dom_1.Switch, { children: [(0, jsx_runtime_1.jsx)(helper_1.RouteWrapper, { path: constants_1.ROUTES.CLASS.NEW, track: constants_1.PAGE_VIEW_EVENTS.CLASS.NEW, render: (0, withSuspense_1.default)(ClassContent) }), (0, jsx_runtime_1.jsx)(helper_1.RouteWrapper, { path: exports.EDIT_CLASS_ROUTE, track: constants_1.PAGE_VIEW_EVENTS.CLASS.EDIT, render: (0, withSuspense_1.default)(ClassManager) }), (0, jsx_runtime_1.jsx)(helper_1.RouteWrapper, { path: constants_1.ROUTES.CLASS.LIST, track: constants_1.PAGE_VIEW_EVENTS.CLASS.MAIN, render: (0, withSuspense_1.default)(ClassListView) })] }));
    }
}
exports.default = ClassManagerIndex;
